var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "buy" }, [
    _c("div", { staticClass: "buy-top" }, [
      _c("img", {
        staticClass: "desc",
        attrs: { src: require("@/assets/imgs/recharge/desc.png") }
      }),
      _c("div", { staticClass: "card" }, [
        _c("img", {
          staticClass: "medal",
          attrs: { src: require("@/assets/imgs/recharge/medal.png") }
        }),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "line" }, [
            _c("p", { staticClass: "name" }, [
              _vm._v(_vm._s(_vm.detail.vipName))
            ]),
            _c("p", { staticClass: "price" }, [
              _c("span", [_vm._v("¥")]),
              _vm._v(_vm._s(_vm.priceYuan(_vm.detail.discountsPrice)))
            ])
          ]),
          _c("div", { staticClass: "line" }, [
            _c("p", { staticClass: "name" }, [
              _vm._v("购买规格：" + _vm._s(_vm.detail.dayType))
            ]),
            _c("p", { staticClass: "price" }, [
              _vm._v("原价 ¥" + _vm._s(_vm.priceYuan(_vm.detail.originalPrice)))
            ])
          ])
        ])
      ])
    ]),
    _c(
      "div",
      { staticClass: "buy-bottom" },
      [
        _c(
          "van-cell-group",
          { staticClass: "buy-member buy-member-bold" },
          [
            _c("van-cell", {
              attrs: { title: "订单价格" },
              scopedSlots: _vm._u([
                {
                  key: "right-icon",
                  fn: function() {
                    return [
                      _c("span", { staticClass: "members-price" }, [
                        _vm._v(
                          "￥" +
                            _vm._s(_vm.priceYuan(_vm.detail.discountsPrice))
                        )
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        ),
        _c(
          "van-cell-group",
          { staticClass: "buy-member", attrs: { border: false } },
          [
            _c("van-cell", {
              attrs: { title: "订单价格" },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function() {
                    return [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/imgs/members/wx.png"),
                          alt: "微信"
                        }
                      }),
                      _c("span", { staticClass: "custom-title" }, [
                        _vm._v("微信支付")
                      ])
                    ]
                  },
                  proxy: true
                },
                {
                  key: "right-icon",
                  fn: function() {
                    return [
                      _c("div", [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/imgs/services/buy-checked.png"),
                            alt: "选中"
                          }
                        })
                      ])
                    ]
                  },
                  proxy: true
                }
              ])
            })
          ],
          1
        ),
        _c("div", { staticClass: "flex service" }, [
          _c("div", { on: { click: _vm.selectService } }, [
            _vm.isAgree
              ? _c("img", {
                  attrs: {
                    src: require("@/assets/imgs/members/xz.png"),
                    alt: "未选中"
                  }
                })
              : _c("img", {
                  attrs: {
                    src: require("@/assets/imgs/members/uncheck.png"),
                    alt: "选中"
                  }
                })
          ]),
          _c("span", [
            _vm._v("支付即代表同意 "),
            _c(
              "a",
              {
                attrs: {
                  href: _vm.protocols.lawyer_value_added_service_protocol
                }
              },
              [_vm._v("《增值服务购买协议》")]
            )
          ])
        ])
      ],
      1
    ),
    _c("div", { staticClass: "footer tc" }, [
      _c("button", { on: { click: _vm.pay } }, [_vm._v("立即支付")])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }